import { t } from "@/i18n-js/instance";
import { Toolbar } from "../../Room/Toolbar";

interface InfoButtonProps {
  onClick: () => void;
}

export const InfoButton = ({ onClick }: InfoButtonProps) => (
  <Toolbar.IconButton
    icon="16-info"
    tooltipText={t(`live_streams.room.button_tooltips.stream.info`)}
    onClick={onClick}
  />
);
